import type { IngestAlert } from "../api/types";

export const KIT_UPDATE_COMMANDS = [
  "cd <dossier où vous avez cloné timesheet-kit>",
  "git pull",
  "./install.sh",
].join("\n");

const KIT_PUSH_SCRIPT = "bun ~/.claude/scripts/timesheet-tawa-push.ts";

export type KitAlertState = "outdated" | "resend";

export function isKitOutdatedAlert(alert: IngestAlert): boolean {
  return alert.vendor === "timesheet-kit" && alert.reason === "client_outdated";
}

/** « resend » dès qu'un envoi a été accepté après le dernier refus : le poste
 * est à jour, seules les journées refusées restent à renvoyer. À horodatage
 * égal, l'acceptation l'emporte (`>=`) : le poste est considéré à jour. */
export function kitAlertState(alert: IngestAlert): KitAlertState {
  if (!alert.accepted_version || !alert.last_accepted_at) return "outdated";
  return Date.parse(alert.last_accepted_at) >= Date.parse(alert.last_refused_at)
    ? "resend"
    : "outdated";
}

export function kitCatchUpCommand(days: string[]): string {
  return `${KIT_PUSH_SCRIPT} --force --days ${days.join(",")}`;
}

const REFUSED_DAY_FORMAT = new Intl.DateTimeFormat("fr-FR", {
  timeZone: "UTC",
  weekday: "long",
  day: "numeric",
  month: "long",
});

/** « 2026-09-30 » → « mercredi 30 septembre ». Construit en UTC et formaté en
 * UTC : le jour calendaire ne dépend pas du fuseau du navigateur. */
export function formatRefusedDay(day: string): string {
  const [y, m, d] = day.split("-").map(Number) as [number, number, number];
  return REFUSED_DAY_FORMAT.format(new Date(Date.UTC(y, m - 1, d)));
}
